import IconClose from "./icon-close.svg?react";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { useVideoPlayer } from "@hooks/videoplayer";
import { hideVideoDisplay } from "@store/globalVideoSlice";
import { useState } from "react";
import { Trans } from "react-i18next";
import { Events } from "xgplayer";
import { Tooltip } from "antd";
import { IconNoDownload } from "@icons/index";
import { IconDownload } from "@icons/dark";
import ScriptBtnGroup from "@components/ScriptBtnGroup";
import "./index.scss";
import { DownloadVideo } from "@components/DownloadVideo";

//（竖屏 9:16 / 横屏 16:9
const getPlayerSize = (aspectRatio?: string) => {
  const isHorizontal = aspectRatio === "RATIO_16_9" || aspectRatio === "16:9";
  if (isHorizontal) return { width: 872, height: 490 };
  return { width: 360, height: 640 };
};

const VideoPlayer = ({ videoURL }: { videoURL: string }) => {
  const dispatch = useAppDispatch();
  const { videoId, videoSource, videoType, aspectRatio, hideDownload } = useAppSelector(
    (state) => state.globalVideoReducer,
  );
  const [isCanPlay, setIsCanPlay] = useState(false);
  const { width, height } = getPlayerSize(aspectRatio);

  const { refPlayer } = useVideoPlayer(
    {
      id: "videoplayer",
      url: videoURL,
      ignores: ["cssFullScreen", "playbackrate"],
      download: false,
      width,
      height,
    },
    [
      {
        eventName: Events.USER_ACTION,
        handle: (data: any) => {
          if (data.eventType === "click" && data.action === "download") {
            // dispatch(updateDownloadingVideos({ region: region, videoId: videoId as string }));
          }
        },
      },
      {
        eventName: Events.CANPLAY,
        handle: () => {
          setIsCanPlay(true);
        },
      },
    ],
    {
      kalo_pos: "videoplayer",
      kalo_type: videoId as string,
    },
  );

  return (
    <div className="relative bg-kds-bg rounded-[8px] p-[12px]!  videoPlayer">
      <div id="videoplayer" className="bg-white"></div>
      <div
        className="w-[40px] h-[40px] rounded-full bg-kds-mask flex items-center justify-center cursor-pointer absolute top-0 -right-[60px]"
        onClick={() => dispatch(hideVideoDisplay())}
      >
        <IconClose></IconClose>
      </div>
      <div className={`absolute top-[24px] right-[24px] flex gap-[8px] ${hideDownload ? "hidden" : ""}`}>
        <Tooltip
          title={
            <div className="font-medium text-kds-fg text-[12px]">
              <Trans>No Watermark</Trans>
            </div>
          }
          getPopupContainer={(triggerNode) => triggerNode?.parentNode as HTMLElement}
          overlayClassName="script-download-tooltip"
          open={isCanPlay ? undefined : false}
        >
          <DownloadVideo videoURL={videoURL} videoId={videoId as string} videoSource={videoSource as string}>
            <div
              className="min-w-[50px] px-[12px] py-[8px] flex flex-col gap-[4px] items-center justify-center rounded-[4px] cursor-pointer transition-all bg-kds-mask"
              onClick={(event) => {
                if (!isCanPlay) event.stopPropagation();
              }}
            >
              {isCanPlay ? (
                <IconDownload className="w-[20px] h-[20px] p-[2px]" />
              ) : (
                <IconNoDownload className="w-[20px] h-[20px] p-[2px]" />
              )}
              <span className="text-[12px] text-white">
                <Trans>Download</Trans>
              </span>
            </div>
          </DownloadVideo>
        </Tooltip>
      </div>
      {videoType === "video_btn" && (
        <div className="flex gap-[8px] mt-[12px]">
          <ScriptBtnGroup
            videoId={videoId as string}
            videoSource={videoSource as string}
            onBtnClick={() => {
              refPlayer.current?.pause();
            }}
            kalo_pos="video_popup"
          />
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
